const header = document.querySelector('.header');
const LinkList = document.querySelector('.internal-anchor-links-container ul');
const blocks = document.querySelectorAll('.block.rte');
const currentPathname = window.location.pathname;

if(LinkList && blocks){
    blocks.forEach((block) => {
        if(block.id) {
            const li = document.createElement("li");
            const a = document.createElement("a");
            const title = block.querySelector('h2')?.textContent;
            const link = currentPathname + "#" + block.id;

            a.setAttribute("href", link);
            a.textContent = title;

            a.addEventListener("click", (e) => {
                e.preventDefault();
                const linkId = a.hash;
                const elem = document.querySelector(linkId);
                let windowPageYOffset = 0;

                // when the user has scrolled the page
                if(header.classList.contains('scrolling')) {
                    // Note: 100px is the shrinked header height
                    windowPageYOffset = window.pageYOffset - 100;
                // when the user still at the top of the page (not scrolling yet)
                } else {
                    // Note: 200px is the original header height
                    windowPageYOffset = window.pageYOffset - 200;
                }

                const elemDistanceToTop = windowPageYOffset + elem.getBoundingClientRect().top;

                window.scrollTo(0, elemDistanceToTop);
            })

            li.appendChild(a);
            LinkList.appendChild(li);
        }
    })
}
